import { thunk } from 'easy-peasy';
import api from '~/services/api';

import { IThunkAddCrisisAllocation } from '../types';

const onAddCrisisAllocation: IThunkAddCrisisAllocation = thunk(
  async (_actions, { clinicId, payload }) => {
    await api.crisis.addCrisisAllocation(clinicId, payload);
  },
);

export default onAddCrisisAllocation;
